import React, { useState } from 'react';
import '../css/StudentApplyAdmission.css'; // Import your CSS file
import DemoImg  from "../img/nobody.png";
import DemoSig from "../img/sample_sig.jpg";
import { useStudentAdmissionMutation } from '../rtkq/services/userAuthApi';

export const StudentApplyAdmission = () => {
  // State to manage form data
  const [formData, setFormData] = useState({
    admissionFor: '',
    // admissionGroup: '',
    studentFirstName: '',
    studentLastName: '',
    studentEmail: '',
    studentPhoneNumber: '',
    // studentImage: DemoImg, 
    // studentSignature: DemoSig, 
    studentGender: '',
  });

  const [error, setError] = useState(false);
  const [studentAdmission, { isLoading }] = useStudentAdmissionMutation();


const handleInputChange = (event) => {
    const { name, value, type, files } = event.target;
    let fileData = value;
  
    if (type === 'file' && files.length > 0) {
      // Handle the file input
      fileData = files[0];
    }
  
    setFormData((prevData) => ({
      ...prevData,
      [name]: fileData,
    }));
  }
  


  const handleSubmit = async (event) => {
    event.preventDefault();

    
    try {
      const res = await studentAdmission(formData);

      if (res.error) {
        console.log("Login error:", res.error);
        setError(true); // Show an error message
      }

      if (res.data) {
        console.log("Login successful:", res.data);
        // navigate('/apply_student_admission');
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }

  }



  return (
    
    <div className="student-admission-container">
      <h1 className='title-1'>Apply For Student Admission</h1>
      <form className="student-admission-form" onSubmit={handleSubmit}>
        

        {/* Admission Information */}
        <div className="admission-info">
          <h2 className='title-2'>Admission Information</h2>

          <div className='admission-form-col'>
            <div className='admission-form-row'>
              <div className='admission-form-info'>
                <label>Admission for <strong>*</strong> </label>
                <select name="admissionFor" value={formData.admissionFor} onChange={handleInputChange} required >
                  <option disabled value="Class1">Select</option>
                  <option value="Class1">Class 4</option>
                  <option value="Class2">Class 5</option>
                  <option value="Class2">Class 6</option>
                  <option value="Class2">Class 7</option>
                </select>
              </div>
              { /*<div className='admission-form-info'>
                <label>Admission Group <strong>*</strong> </label>
                <select name="admissionGroup" value={formData.admissionGroup} onChange={handleInputChange} required >
                  <option disabled value="Science">Select</option>
                  <option value="Science">Science</option>
                  <option value="Arts">Arts</option>
                  <option value="Commerce">Commerce</option>
                  <option value="General">General</option>
                </select>
              </div> */}
            </div>
          </div>

        </div>


        {/* Personal Information */}
        <div className="personal-info">
          <h2 className='title-2'>Personal Information</h2>

           {/*<div className="admission-form-col">
            <div className="admission-form-row">

              <div className='admission-form-info'>
                <label>Student Image <strong>*</strong> </label>
                <input
                  type="file"
                //   accept=".jpg, .jpeg, .png"
                  name="studentImage"
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className='admission-form-info'>
                <img className='student-image' src={formData.studentImage} alt="studentImage" />
              </div>
              
            </div>
          </div>

          <div className="admission-form-col">
            <div className="admission-form-row">

              <div className='admission-form-info'>
                <label>Student Signature <strong>*</strong> </label>
                <input
                  type="file"
                  // accept=".jpg, .jpeg, .png"
                  name="studentSignature"
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className='admission-form-info'>
                <img className='student-signature' src={formData.studentSignature} alt="studentSignature" />
              </div>
              
            </div>
          </div> */}

          <div className="admission-form-col">
            <div className="admission-form-row">

              <div className='admission-form-info'>
                <label>First Name <strong>*</strong></label>
                <input
                  type="text"
                  name="studentFirstName"
                  value={formData.studentFirstName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className='admission-form-info'>
                <label>Last Name <strong>*</strong></label>
                <input
                  type="text"
                  name="studentLastName"
                  value={formData.studentLastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className='admission-form-info'>
                <label>Student E-mail address <strong>*</strong></label>
                <input
                  type="email"
                  name="studentEmail"
                  value={formData.studentEmail}
                  onChange={handleInputChange}
                  required
                />
              </div>

            </div>
          </div>

          <div className="admission-form-col">
            <div className="admission-form-row">

              <div className='admission-form-info'>
                <label>Student Phone Number <strong>*</strong></label>
                <input
                  type="tel"
                  name="studentPhoneNumber"
                  value={formData.studentPhoneNumber}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="submit-button">
          <button type="submit">Apply</button>
        </div>


      </form>
    </div>
  );
};
  